import * as React from 'react';
import MaterialUICircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';
import {
  Theme,
  withStyles,
  WithStyles,
  withTheme,
  WithTheme
  } from '@material-ui/core/styles';

const styles = (theme: Theme) => ({
  root: {
    margin: theme.spacing(2)
  }
});

type Props = WithStyles<typeof styles> & WithTheme & CircularProgressProps;

const CircularProgressComponent: React.FC<Props> = ({ classes, theme, className = '', ...props }) => (
  <MaterialUICircularProgress size={theme.spacing(4)} className={`${classes.root} ${className}`} {...props} />
);

export const CircularProgress = withStyles(styles)(withTheme(CircularProgressComponent));
